import type { AxiosInstance } from 'axios';
import authService from './auth.service';

/**
 * The countries the offering is made in: the country switch, read by any signed-in person.
 *
 *   GET /api/v1/offering/markets   the ISO codes switched on, in the switch's own order
 *
 * The line on client screens that names where the offering is made is built from this answer
 * and never from a list kept in the frontend.
 */
class OfferingService {
  private get api(): AxiosInstance {
    return authService.getApi();
  }

  async markets(): Promise<string[]> {
    const res = await this.api.get<{ markets: string[] }>('/api/v1/offering/markets');
    return res.data.markets;
  }
}

export default new OfferingService();
